import React, { useEffect } from "react";
import Ellipse1611 from "../../assets/images/Ellipse 1611.png";
import Ellipse1608 from "../../assets/images/Ellipse 1608.png";
import Ellipse1609 from "../../assets/images/Ellipse 1609.png";
import Ellipse1610 from "../../assets/images/Ellipse 1610.png";

import back_arrow from "../../assets/images/back_arrow.png";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


/**
 * Renders Component.
//  * @return {ChooseProfile} renders Component.
 */
export default function ChooseProfile() {
    useEffect(() => { }, []);

    return (
        <>
            <div className="cmmn">


                <Container>
                    <div className="mt-3 p-075 d-flex align-items-center justify-content-center">



                        <h6 className="mb-0 ms-3 admin_hdclr fw-bold">Choose Profile</h6>



                    </div>


                    <Row className="mt-5 m-auto justify-content-around">
                        <Col xs={5} className="col-sm-4 mb-2 d-flex flex-column align-items-center">
                            <div role="button" className="text-decoration-none status_clr">
                                <div className="mb-2">

                                    <img src={Ellipse1608} alt="..." className="rounded-circle" width="80px" height="80px" />


                                </div>
                                <div className="mx-auto text-center link_style">
                                    <p className="f-14 mb-0">  Kiran Kumar </p>
                                    <p className="f-12">Student1</p>
                                </div>
                            </div>

                        </Col>
                        <Col xs={5} className="col-sm-4 mb-2 mt-auto px-075 d-flex flex-column align-items-center">
                        <div role='button' className="text-decoration-none status_clr">

                            <div className="mb-2">

                                <img src={Ellipse1611} alt="..." className="rounded-circle" width="80px" height="80px" />


                            </div>
                            <div className="mx-auto text-center link_style">
                                <p className="f-14 mb-0">  Michelle Adams </p>
                                <p className="f-12">Teacher</p>
                            </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4 m-auto justify-content-around">

                        <Col xs={5} className="col-sm-4 mb-2 mt-auto d-flex flex-column align-items-center">
                        <div role="button" className="text-decoration-none status_clr">

                            <div className="mb-2">

                                <img src={Ellipse1609} alt="..." className="rounded-circle" width="80px" height="80px" />


                            </div>
                            <div className="mx-auto text-center link_style">
                                <p className="f-14 mb-0">  Kyle Wallace </p>
                                <p className="f-12">Admin</p>
                            </div>
                            </div>
                        </Col>
                        <Col xs={5} className="col-sm-4 mb-2 mt-auto d-flex flex-column align-items-center">
                        <div role="button" className="text-decoration-none status_clr">

                            <div className="mb-2">

                                <img src={Ellipse1610} alt="..." className="rounded-circle" width="80px" height="80px" />


                            </div>
                            <div className="mx-auto text-center link_style">
                                <p className="f-14 mb-0">  Frank Marshall </p>
                                <p className="f-12">Student2</p>
                            </div>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        </>
    );
}

